import leftControl from './designer_tab/leftControl';
import centerControl from './designer_tab/centerControl';
import rightControl from './designer_tab/rightControl';

export default {
    template: '#designer_tab',
    props: ['selectedProduct', 'designerItems', 'currentSide'],
    methods: {},
    components: {
        'left-control': leftControl,
        'center-control': centerControl,
        'right-control': rightControl
    }
}


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designerTab.js